import "css/mobile/index.scss";
import "js/mobile/common/common.jquery.js";
import Swiper from "swiper";

var swiper = new Swiper(".swiper-container", {
  slidesPerView: "auto",
  spaceBetween: 16,
  freeMode: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
